export const ABOUT_ME_APP_ID = 'about-me-overview';
export const HEALTH_REPORT_APP_ID = 'health-assessment-report';
export const ABOUT_ME_MASONRY_API_VERSION = 1;
